import './index.css'
import React from 'react'
import { LOGOS_SVG } from './constants'
import { LecturaDispositivo } from './interface'
import { formatearFecha, formatosFecha } from 'util/formatDate';

interface IPropsCardTelemetria {
     data: LecturaDispositivo[];
}

const CardTelemetriaElement = ({ data }: IPropsCardTelemetria) => {
     const row = data[0];

     const ITEM_EXCLUDES = ['nombre_dispositivo']
     const KEY_FECHA_LECTURA = 'rtc'

     return (
          <div className='container__telemetria'>
               {Object.entries(row).map(([key, value]) => {
                    const VALUE = key === KEY_FECHA_LECTURA ? formatearFecha(value, formatosFecha.completaServidor) : value

                    if (!ITEM_EXCLUDES.includes(key)) {
                         return (
                              <div key={key} className="item__telemetria">
                                   <p className='title__item'>{key.replaceAll('_', ' ').toLocaleUpperCase()}</p>
                                   {LOGOS_SVG[key] && <span className='logo__item'>{LOGOS_SVG[key]}</span>}
                                   <p className='value__item'>{String(VALUE)}</p>
                              </div>
                         )
                    }
               })}
          </div>
     );
};


export default CardTelemetriaElement